import { FC, useState } from 'react';
import { Button, ButtonGroup, Editable, EditableInput, EditablePreview, Flex, useEditableControls } from '@chakra-ui/react';
import { ICON_BY_NAME } from './../../Icons/Icon';
import { OptionalTooltip } from 'components/OptionalTooltip';
export interface CbInlineEditableProps {
  isDisabled?: boolean;
  defaultValue: string;
  size?: string;
  withControls?: boolean;
  isDarkMode?: boolean;
  onSubmit: (nextValue: string) => void;
  tooltip?: (value: string) => string;
}
export const CbInlineEditable: FC<CbInlineEditableProps> = ({
  isDisabled,
  defaultValue,
  onSubmit,
  size,
  withControls = false,
  isDarkMode = false,
  tooltip,
  ...props
}) => {
  const [_, setValue] = useState<string>(defaultValue);
  const [inputValue, setInputValue] = useState<string>(defaultValue);
  const EditableControls: FC = () => {
    const {
      isEditing,
      getSubmitButtonProps,
      getCancelButtonProps,
      getEditButtonProps
    } = useEditableControls();
    return isEditing ? <ButtonGroup justifyContent="center" size="sm" marginLeft={2} data-sentry-element="ButtonGroup" data-sentry-component="EditableControls" data-sentry-source-file="CbInlineEditable.tsx">
        <Button variant="link" {...getSubmitButtonProps()} data-sentry-element="Button" data-sentry-source-file="CbInlineEditable.tsx">
          <ICON_BY_NAME.check margin="0" height={3} width={3} data-sentry-element="unknown" data-sentry-source-file="CbInlineEditable.tsx" />
        </Button>
        <Button variant="link" {...getCancelButtonProps()} data-sentry-element="Button" data-sentry-source-file="CbInlineEditable.tsx">
          <ICON_BY_NAME.close margin="0" height={3} width={3} data-sentry-element="unknown" data-sentry-source-file="CbInlineEditable.tsx" />
        </Button>
      </ButtonGroup> : <Flex justifyContent="center" marginLeft={2} data-sentry-element="Flex" data-sentry-component="EditableControls" data-sentry-source-file="CbInlineEditable.tsx">
        <Button variant="link" {...getEditButtonProps()} data-sentry-element="Button" data-sentry-source-file="CbInlineEditable.tsx">
          <ICON_BY_NAME.edit margin="0" height={3} width={3} data-sentry-element="unknown" data-sentry-source-file="CbInlineEditable.tsx" />
        </Button>
      </Flex>;
  };
  return <Editable display="flex" justifyContent="space-between" alignItems="center" defaultValue={defaultValue} isDisabled={isDisabled} isPreviewFocusable={!withControls} size={size || 'xs'} textAlign="center" onChange={nextValue => setInputValue(nextValue)} onSubmit={nextValue => onSubmit(nextValue)} onCancel={previousValue => setValue(previousValue)} submitOnBlur={false} _hover={!isDisabled && !withControls ? {
    backgroundColor: 'rgba(0,0,0,0.08)',
    borderRadius: '4px',
    cursor: 'pointer'
  } : undefined} paddingX={2} {...props} data-sentry-element="Editable" data-sentry-component="CbInlineEditable" data-sentry-source-file="CbInlineEditable.tsx">
      <EditablePreview data-sentry-element="EditablePreview" data-sentry-source-file="CbInlineEditable.tsx" />
      <OptionalTooltip content={tooltip ? tooltip(inputValue) : undefined} data-sentry-element="OptionalTooltip" data-sentry-source-file="CbInlineEditable.tsx">
        <EditableInput maxWidth={16} data-sentry-element="EditableInput" data-sentry-source-file="CbInlineEditable.tsx" />
      </OptionalTooltip>
      {!!withControls && !isDisabled && <EditableControls />}
    </Editable>;
};